import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-slate-800">
      <Seo
        title="Política de Privacidade | Web & Studio"
        description="Política de Privacidade da Web & Studio: tratamento de dados, finalidade, retenção e direitos do titular."
        path="/privacy"
      />

      <main className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="mb-10">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-800 font-medium">
            Voltar ao início
          </Link>
        </div>

        <header className="space-y-4 mb-12">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900">
            Política de Privacidade
          </h1>
          <p className="text-slate-600">
            Última atualização: 16 de fevereiro de 2026.
          </p>
        </header>

        <section className="space-y-8 leading-relaxed">
          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">1. Responsável pelo tratamento</h2>
            <p>
              A Web & Studio é responsável pelo tratamento dos dados pessoais recolhidos através do formulário de contacto.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">2. Dados recolhidos</h2>
            <p>
              Recolhemos nome, email e mensagem quando envia um pedido através do site.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">3. Finalidade e base legal</h2>
            <p>
              Os dados são utilizados para responder ao pedido de contacto e para comunicações relacionadas com serviços solicitados.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">4. Conservação dos dados</h2>
            <p>
              Conservamos os dados apenas pelo período necessário para gerir o contacto e cumprir obrigações legais aplicáveis.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">5. Direitos do titular</h2>
            <p>
              Pode solicitar acesso, retificação, apagamento, limitação, oposição e portabilidade dos seus dados através do email de contacto.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-slate-900 mb-2">6. Contacto</h2>
            <p>
              Para questões de privacidade, contacte:{" "}
              <a className="text-teal-700 hover:text-teal-800" href="mailto:contacto@webestudio.pt">
                contacto@webestudio.pt
              </a>
              .
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
